import TheadCustom from "@ui/tableCustom/view/ui/theadCustom/TheadCustom";
import TrCustom from "@ui/tableCustom/view/ui/trCustom/TrCustom";
import {HeadColumns, mapperColumnCbType} from "@ui/tableCustom/types/table";
import {IQueryParamsContext} from "@hooks/query/types/queryParams";
import {
    IExportMutateContext,
    IExportParamsContext
} from "@containers/export/containers/buildData/hooks/types/exportParams";
import CurrentColumn from "@ui/tableCustom/head/CurrentColumn";
import CurrentTr from "@ui/tableCustom/head/CurrentTr";
import {sx} from './sx'

interface IProps<T> {
    columns: HeadColumns<T>,
    exportParams: IExportParamsContext<T>,
    exportMutate: IExportMutateContext<T>,
    mapperColumnCb?: mapperColumnCbType<T>,
    params: IQueryParamsContext<T>,
}

function TableCustomHead<T>({
                                columns,
                                mapperColumnCb,
                                exportMutate,
                                exportParams,
                                params,
                            }: IProps<T>) {

    const isArray = columns?.length >=1 && Array.isArray(columns[0])

    const list = columns && columns.map((item, index) => {
        if (Array.isArray(item)) {
            return (
                <TrCustom
                    sx={sx.tr}
                    key={index}
                >
                    {item.map((it, i) => {
                        return (
                            <CurrentColumn
                                key={it?.id?.toString() || i}
                                column={it}
                                exportParams={exportParams}
                                exportMutate={exportMutate}
                                mapperColumnCb={mapperColumnCb}
                                params={params}
                                index={i}
                                globalIndex={index}
                            />
                        )
                    })}
                </TrCustom>
            )
        }
        return (
            <CurrentColumn
                key={item.id?.toString() || index}
                column={item}
                exportParams={exportParams}
                exportMutate={exportMutate}
                mapperColumnCb={mapperColumnCb}
                params={params}
                index={index}
            />
        )

    })


    return (
        <TheadCustom>
            <CurrentTr hasTr={!isArray}>
                {list}
            </CurrentTr>
        </TheadCustom>
    )

}


export default TableCustomHead;